'use strict'

IAM_EVENTS = {
  FETCH_CALL_FAILED: 'iam-call-failed'
  RECORD_EVENT_CALL_FAILED: 'iam-record-event-call-failed'
}

INBOX_SELECTORS = {
  ITEM_CLASS: '.ls-inbox-item'
  ITEM_JUST_VIEWED_CLASS: 'ls-inbox-item-just-viewed'
  ITEM_VIEWED_CLASS: 'ls-inbox-item-viewed'
  ITEM_UNVIEWED_CLASS: 'ls-inbox-item-unviewed'
}

getDataForQueryParams = ->
  { app, categoryid, locale } = document.head.dataset
  c_cookie = Cookie.get("c")?.replace(/"/g, '') # We save c_cookie enclosed by quotes. We need to remove them.
  return {
    app
    categoryid
    locale
    c_cookie
  }

fetchJSON = (cb) ->
  { app, categoryid, locale, c_cookie } = getDataForQueryParams()
  isViewportExperiment = Groupon.LS.experiments['LS-2120-IAM-Viewport-Param']
  isTouchRequest = Optimize.suiteData.config.user.platform is 'touch' or Groupon.PageFlags?.isTouchRequest
  data = {
    app_name: app if not isTouchRequest
    division_id: Groupon?.division?.id
    device_id: 'ITIER-DEVICE_ID' if isTouchRequest
    consumer_id: c_cookie if c_cookie
    locale: locale
    category_id: categoryid if categoryid
    page: 1
    per_page: 200
    viewport: document.documentElement.clientWidth if isViewportExperiment
  }

  params = new URLSearchParams()
  Object.keys(data).forEach (key) ->
    if value = data[key]
      try
        params.append(key, value)

  url = (Groupon.endpoints?.in_app_messages?.fetch or '/in_app_messages') + '?' + params.toString()
  fetch(url, {
    credentials: 'include'
    headers: {
      'x-ls-locale': params.locale
    }
  })
  .then (res) ->
    if !res.ok
      throw ({ event: IAM_EVENTS.FETCH_CALL_FAILED })
    return res.json()
  .then (json) ->
    if not json or json.err
      json ?= { err: 'Fetch call failed' }
      { err } = json
      throw ({ event: IAM_EVENTS.FETCH_CALL_FAILED, error: err })
    return cb(json)
  .catch (e) ->
    unless e.event?
      e = { event: IAM_EVENTS.FETCH_CALL_FAILED, error: e }
    Groupon.Utils.trackEvent e.event, e.error
    return cb({ inbox: null, banner: null })

recordEvent = (messageIds, eventName, cb) ->
  cb ?= ->

  { app, categoryid, locale, c_cookie } = getDataForQueryParams()
  data = {
    app_name: app if not Groupon.PageFlags?.isTouchRequest
    division_id: Groupon?.division?.id
    device_id: 'ITIER-DEVICE_ID' if Groupon.PageFlags?.isTouchRequest
    consumer_id: c_cookie if c_cookie
    locale: locale
    categoryId: categoryid if categoryid
    messages: messageIds
    eventName: eventName.toUpperCase()
  }
  params = new URLSearchParams()
  Object.keys(data).forEach (key) ->
    if value = data[key]
      try
        params.append(key, value)

  url = (Groupon.endpoints?.in_app_messages?.record_event or '/in_app_messages/record_event') + '?' + params.toString()
  fetch(url, {
    credentials: 'include'
    headers: {
      'x-ls-locale': params.locale
    }
  })
  .then (res) ->
    if !res.ok
      throw ({ event: IAM_EVENTS.RECORD_EVENT_CALL_FAILED })
    cb(true)
    return
  .catch (e) ->
    unless e.event?
      e = { event: IAM_EVENTS.RECORD_EVENT_CALL_FAILED, error: e }
    Groupon.Utils.trackEvent e.event, e.error
    cb(false)

recordViewedEvent = (inboxElem) ->
  messages = Array.from(inboxElem.querySelectorAll(INBOX_SELECTORS.ITEM_CLASS))
  messageIds = messages.reduce (collection, m) ->
    if m.classList.contains(INBOX_SELECTORS.ITEM_UNVIEWED_CLASS)
      m.classList.remove(INBOX_SELECTORS.ITEM_UNVIEWED_CLASS)
      m.classList.add(INBOX_SELECTORS.ITEM_JUST_VIEWED_CLASS)
      collection.push m.dataset.id
    else if m.classList.contains(INBOX_SELECTORS.ITEM_JUST_VIEWED_CLASS)
      m.classList.remove(INBOX_SELECTORS.ITEM_JUST_VIEWED_CLASS)
      m.classList.add(INBOX_SELECTORS.ITEM_VIEWED_CLASS)
    return collection
  , []

  if messageIds.length > 0
    recordEvent(messageIds, "VIEWED")

wireMessageClick = (inboxElem, cb) ->
  itemElems = inboxElem.querySelectorAll(INBOX_SELECTORS.ITEM_CLASS)
  [].forEach.call itemElems, (el) ->
    el.addEventListener 'click', ->
      recordEvent el.dataset.id, "CLICKED", (success) ->
        window.location.href = el.dataset.target
    , { passive: true }
  return

module.exports = {
  fetchJSON,
  recordViewedEvent,
  wireMessageClick
}
